import { AddressForm } from '@/components/address-form'
import { DocumentNumberInput } from '@/components/document-number-input'
import { GroupInput } from '@/components/v2/group-input'
import { activitiesOptions } from '@/constants/activities'
import { PhoneNumberInput } from '@/shared/components/phone-number-input'
import { useGetServiceAreasQuery } from '@/store/services/service-area.service'
import { toOptions } from '@/utils'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CustomSelect from '@/shared/components/custom-select'
import { InputHelperText } from '@/shared/components/input-helper-text'

export const LegalInformationForm = () => {
  const { t } = useTranslation()
  const { errors, values, handleChange, setFieldValue } = useFormikContext()
  const { data: serviceAreas = [] } = useGetServiceAreasQuery('per_page=999')

  const serviceAreasOpts = useMemo(() => {
    return toOptions({ data: serviceAreas })
  }, [serviceAreas])

  const currentServiceAreas = serviceAreasOpts.filter((serviceAreaOpt) =>
    values.service_area_ids.includes(serviceAreaOpt.value)
  )

  return (
    <GroupInput
      title={t('company.sections.legalInformation')}
      description='Rellena la información general de la empresa contratista.'
      className='py-8'
    >
      <div className='grid grid-cols-2 gap-4'>
        <div>
          <DocumentNumberInput
            required
            name='document_number'
            label={t('documentNumber.one')}
            value={values.document_number}
            onChange={handleChange}
            error={Boolean(errors.document_number)}
          />
          <InputHelperText label={errors.document_number} color='red' />
        </div>

        <Input
          required
          name='name'
          label={t('company.name')}
          value={values.name}
          onChange={handleChange}
        />

        <Input
          name='trade_name'
          label={t('company.trade_name')}
          value={values.trade_name}
          onChange={handleChange}
        />

        <Input
          name='business_line'
          label={t('company.business_line')}
          value={values.business_line}
          onChange={handleChange}
        />

        <CustomSelect
          name='activity'
          placeholder={t('common.activity')}
          options={activitiesOptions}
          value={activitiesOptions.find(
            (activity) => activity.label === values.activity
          )}
          onChange={({ label }) => setFieldValue('activity', label)}
        />

        <CustomSelect
          isMulti
          required
          placeholder={t('serviceArea.one')}
          options={serviceAreasOpts}
          value={currentServiceAreas}
          onChange={(selectedOptions) =>
            setFieldValue(
              'service_area_ids',
              selectedOptions.map((selectedOption) => selectedOption.value)
            )
          }
        />
      </div>

      <div className='grid grid-cols-2 gap-4'>
        <Input
          name='email'
          label={t('email.one')}
          value={values.email}
          onChange={handleChange}
        />

        <PhoneNumberInput
          name='phone'
          label={t('phone.one')}
          value={values.phone}
          onChange={handleChange}
        />
      </div>

      <div className='grid grid-cols-3 gap-4'>
        <AddressForm />
      </div>
    </GroupInput>
  )
}